// extracted by mini-css-extract-plugin
module.exports = {"CardsCTA":"CardsCTA_CardsCTA__Xqh3w","grid":"CardsCTA_grid__wJk2t","card":"CardsCTA_card__ZWg4_","image":"CardsCTA_image__cMuEp","text":"CardsCTA_text__6Gzjl"};